import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getNewestBlogPosts } from '../../services/firebase/blogService';
import './HomepageBlogSection.css';

const HomepageBlogSection = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true; // Prevent state updates if component unmounts

    const loadBlogPosts = async () => {
      try {
        setLoading(true);
        const result = await getNewestBlogPosts(8); // Load 8 posts for 2 rows (4 columns)
        
        if (isMounted) {
          if (result.success) {
            setPosts(result.data);
            setError('');
          } else {
            setError(result.error || 'Failed to load blog posts');
            console.error('Blog posts error:', result.error);
          }
        }
      } catch (err) {
        if (isMounted) {
          setError('Error loading blog posts');
          console.error('Blog posts exception:', err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadBlogPosts();

    return () => {
      isMounted = false; // Cleanup function to prevent memory leaks
    };
  }, []);

  if (loading) {
    return (
      <section className="homepage-blog-section">
        <div className="section-header">
          <h2>📚 Latest From Our Blog</h2>
          <p>Discover insights, tips, and stories from our art community</p>
        </div>
        <div className="loading-posts">
          <div className="spinner"></div>
          <p>Loading blog posts...</p>
        </div>
      </section>
    );
  }

  if (error) {
    console.error('Blog section error:', error);
    return (
      <section className="homepage-blog-section">
        <div className="section-header">
          <h2>📚 Latest From Our Blog</h2>
          <p>Discover insights, tips, and stories from our art community</p>
        </div>
        <div className="no-posts-message">
          <p className="message-text">No blogs currently to preview</p>
        </div>
      </section>
    );
  }

  if (posts.length === 0) {
    console.warn('No approved blog posts found');
    return (
      <section className="homepage-blog-section">
        <div className="section-header">
          <h2>📚 Latest From Our Blog</h2>
          <p>Discover insights, tips, and stories from our art community</p>
        </div>
        <div className="no-posts-message">
          <p className="message-text">No blogs currently to preview</p>
        </div>
      </section>
    );
  }

  return (
    <section className="homepage-blog-section">
      <div className="section-header">
        <div>
          <h2>📚 Latest From Our Blog</h2>
          <p>Discover insights, tips, and stories from our art community</p>
        </div>
        <Link to="/blog" className="view-all-link">
          View All Articles →
        </Link>
      </div>

      <div className="blog-posts-grid">
        {posts.map(post => (
          <article key={post.id} className="blog-post-card">
            {post.featuredImage && (
              <Link to={`/blog/${post.id}`} className="post-image-link">
                <img
                  src={post.featuredImage}
                  alt={post.title}
                  className="post-image"
                />
                <div className="post-image-overlay"></div>
              </Link>
            )}

            <div className="post-body">
              <div className="post-category-tag">
                {post.category === 'art' && '🎨'}
                {post.category === 'tutorial' && '📚'}
                {post.category === 'trends' && '📈'}
                {post.category === 'community' && '👥'}
                {post.category === 'news' && '📰'}
                {post.category === 'tips' && '💡'}
                {' '}{post.category}
              </div>

              <Link to={`/blog/${post.id}`} className="post-title-link">
                <h3 className="post-title">{post.title}</h3>
              </Link>

              <p className="post-excerpt">{post.excerpt}</p>

              <div className="post-footer">
                <div className="post-author">
                  {post.vendorAvatar && (
                    <img
                      src={post.vendorAvatar}
                      alt={post.vendorName}
                      className="author-avatar"
                    />
                  )}
                  <div>
                    <p className="author-name">{post.vendorName}</p>
                    <p className="post-date">
                      {new Date(post.createdAt?.toDate?.() || post.createdAt).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                      })}
                    </p>
                  </div>
                </div>

                <Link to={`/blog/${post.id}`} className="read-more">
                  Read More →
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="section-cta">
        <Link to="/blog" className="btn-explore-blog">
          Explore All Articles
        </Link>
      </div>
    </section>
  );
};

export default HomepageBlogSection;
